import React, { useEffect, useState } from "react"
import Header from "../components/support/Header"
import FAQs from "../components/support/FAQs"
import SupportLinks from "../components/support/SupportLinks"
import useLogging from "../hooks/useLogging"

const Support = ({ sidebarOpen }) => {
	const [selectedFaq, setSelectedFaq] = useState(null)
	const logging = useLogging()

	useEffect(() => {
		// Replace these details with the actual user information
		const user = {
			email: "user@example.com",
			fullName: "User Full Name",
			profileImgUrl: "https://example.com/profile.jpg"
		}

		window.pylon = {
			chat_settings: {
				app_id: "830bc5f7-26c1-4d82-b15a-85cc26ffb406",
				email: user.email,
				name: user.fullName,
				avatar_url: user.profileImgUrl
			}
		}
	}, [])

	useEffect(() => {
		logging.info("Selected FAQ updated:", selectedFaq)
		// `logging` is a fresh object each render (useLogging returns inline object); adding it would re-run every render.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedFaq])

	return (
		<div className="bg-gray-50 min-h-screen">
			<div className={`${sidebarOpen ? "pl-64" : "pl-8"}`}>
				<Header setSelectedFaq={setSelectedFaq} />
				<main>
					<div className="px-0 sm:px-0 lg:px-0">
						<SupportLinks />
						<FAQs selectedFaq={selectedFaq} />
					</div>
				</main>
			</div>
		</div>
	)
}

export default Support
